export const AUTH_URL = `/api/auth`;
export const AUTH_V2_URL = `/api/auth/v2`;

export const AUTH_V2_LOCAL_STORAGE_FLAG = "useAuthV2";
